import { render } from "./TeacherList.vue?vue&type=template&id=86c87486&scoped=true&ts=true"
import script from "./TeacherList.vue?vue&type=script&lang=ts"
export * from "./TeacherList.vue?vue&type=script&lang=ts"

import "./TeacherList.vue?vue&type=style&index=0&id=86c87486&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\y-tosa.LOCALPSC\\repo\\seto-solan\\apps\\admin-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-86c87486"]])

export default __exports__